__webpack_require__.p = "/yellow-door/";